import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SolStorageService {
  private localStorageKey = 'SCAM-';
  private userData = new Subject();
  currentUserData = this.userData.asObservable();

  updateUserData(currentUserData) {
    this.userData.next(currentUserData);
  }
  public setItem(key, value) {
    if (window.localStorage) {
      localStorage.setItem(this.localStorageKey + key, value);
    } else {
      return 'Can not access local storage.';
    }
  }

  public setJSONItem(key, value) {
    if (window.localStorage) {
      localStorage.setItem(this.localStorageKey + key, JSON.stringify(value));
    } else {
      return 'Can not access local storage.';
    }
  }

  public getJSONItem(key) {
    if (window.localStorage) {
      return JSON.parse(localStorage.getItem(this.localStorageKey + key));
    } else {
      return 'Can not access local storage.';
    }
  }

  public getItem(key) {
    if (window.localStorage && localStorage.length > 0) {
      return localStorage.getItem(this.localStorageKey + key);
    } else {
      return 'Can not access local storage.';
    }
  }

  public removeItem(key) {
    localStorage.removeItem(this.localStorageKey + key);
  }

  public clearItems() {
    localStorage.clear();
  }
}
